import { index, pgEnum, pgTable, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { journals } from "./journal"
import { users } from "./users"

// Enum for journal invitation status
export const journalInvitationStatusEnum = pgEnum("journal_invitation_status", [
  "PENDING",
  "ACCEPTED",
  "DECLINED",
  "CANCELLED",
])

// Purpose: Manages email-based invitations for journal collaboration with PIN verification
export const journalInvitations = pgTable(
  "journal_invitation",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    journalId: uuid("journal_id")
      .notNull()
      .references(() => journals.id, { onDelete: "cascade" }),
    inviterId: varchar("inviter_id", { length: 255 })
      .notNull()
      .references(() => users.id, { onDelete: "cascade" }),
    inviteeEmail: varchar("invitee_email", { length: 255 }).notNull(),
    pin: varchar("pin", { length: 4 }).notNull(),
    status: journalInvitationStatusEnum("status").notNull().default("PENDING"),
    failedAttempts: varchar("failed_attempts", { length: 255 }).default("[]"), // JSON array of timestamps
    expiresAt: timestamp("expires_at").notNull(),
    acceptedAt: timestamp("accepted_at"),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
    // a database trigger is required. This schema sets the timestamp on creation,
    // and application logic or a trigger should handle updates.
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
  },
  (table) => ({
    // Index for duplicate invitation check and list queries
    inviterIdIdx: index("journal_invitation_inviter_id_idx").on(table.inviterId),
    inviteeEmailIdx: index("journal_invitation_invitee_email_idx").on(table.inviteeEmail),
    journalEmailStatusIdx: index("journal_invitation_journal_email_status_idx").on(
      table.journalId,
      table.inviteeEmail,
      table.status,
    ),
    // Note: Partial unique index (WHERE status = 'PENDING') must be added manually in migration
  }),
)
